import TetrisManager from "./Components/TetrisManager/TetrisManager";
import React from "react";

function App() {
  return (
  <React.Fragment>
    <TetrisManager />
  </React.Fragment>
  );
}

export default App;
